// extracted by mini-css-extract-plugin
export var btn = "M_mB x_s6 x_sK d_bz d_bP d_bD d_dw";
export var full = "M_w1 d_w d_H";
export var hoverStyle = "M_mF";
export var zoom = "M_mG";